<template>
  <div class="content_box">
    <!-- <div class="head_box">
      <img src="../assets/bindCons-shop.png" alt />
      <span class="titleType">店铺</span>
      <span class="titleNum">（已绑定{{consCount}}户，还可以绑定{{10-consCount}}户）</span>
      <van-icon style="position:absolute;right:10px" name="arrow-down" size="20px" />
    </div> -->
    <div class="body_box">
      <div class="list_box" v-for="item in bindConsNoList">
        <div class="cardTitle">
          <div class="consName1">{{ item.consName }}</div>
        </div>
        <div class="cardContent">
          <p class="listAddr">{{ item.elecAddr }}</p>
          <p>用户编号：{{ item.consNo }}</p>
          <!-- <p>有 效 期：--</p> -->
          <p>客户状态：正常</p>
          <p>绑定状态：正常</p>
        </div>
        <div class="carTool">
          <div class="unbind" @click="unBind(item.consId)">
            <img src="../assets/bindCons-relieve.png" alt />
            解绑
          </div>
        </div>
      </div>
    </div>
    <div class="bind_btn" @click="toBind">绑定客户</div>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon } from "vant";
Vue.use(Icon);
import { Notify } from "vant";
import { queryBindConsNoList, unboundConsNo } from "@/api/user.js";
export default {
  data() {
    return {
      consCount: 0,
      bindConsNoList: [],
    };
  },
  created() {
    this.queryBindConsNoList();
  },
  methods: {
    unBind(consNo) {
      unboundConsNo(consNo).then((res) => {
        if (res.data.status == 200) {
          Notify({ type: "success", message: "解绑成功！" });
          this.queryBindConsNoList()
        } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });
    },
    toBind() {
      this.$router.push({
        path: `/tcmr/bindAccount`,
      });
    },
    queryBindConsNoList() {
      queryBindConsNoList().then((res) => {
        if (res.data.status == 200) {
          this.bindConsNoList = res.data.object;
          this.consCount = res.data.object.length;
        }
      });
    },
  },
};
</script>

<style scoped>
.body_box {
  padding: 0.15rem;
}
body {
  background: royalblue;
}
.bind_btn {
  color: #fff;
  height: 0.6rem;
  font-size: 0.26rem;
  line-height: 0.6rem;
  margin: 0rem 0.3rem;
  margin-top: 0.3rem;
  background: #50c7a1;
  border-radius: 0.06rem;
}

.unbind {
  width: 1rem;
  float: right;
  font-size: 14px;
  color: #50c7a0;
  text-align: center;
  line-height: normal;
  border-radius: 0.1rem;
  vertical-align: middle;
  padding: 0.06rem 0.2rem;
  border: 1px solid #50c7a0;
}
.carTool img {
  width: 0.26rem;
  display: inline-block;
  vertical-align: middle;
}

.carTool {
  height: 0.42rem;
  text-align: right;
  position: relative;
  padding: 0.15rem 0.3rem;
}
p {
  margin: 0 0 10px;
}
.cardContent > p {
  margin-bottom: 0.1rem;
  padding: 0;
  color: #666;
  font-size: 0.24rem;
}
.cardContent .listAddr {
  margin-bottom: 0.2rem;
  color: #333;
  font-size: 0.26rem;
}
.cardContent {
  margin: 0 0.3rem;
  text-align: left;
  padding: 0.2rem 0.1rem 0.2rem;
  border-bottom: 1px solid #eee;
}
.cardTitle {
  padding: 0.15rem 0.15rem;
  border-bottom: 1px solid #eee;
}
.consName1 {
  color: #333;
  text-align: left;
  font-size: 0.26rem;
}
.list_box {
  padding: 0.15rem;
  margin-top: 0.15rem;
  border-radius: 0.15rem;
  background-color: #ffffff;
}
.body_box {
  background-color: #f2f2f2;
}
.head_box {
  display: flex;
  position: relative;
  align-items: center;
  padding: 0.3rem 0.2rem;
  background-color: #fff;
}
.titleType {
  color: #50c7a1;
  font-size: 0.32rem;
  margin-left: 0.1rem;
}
.titleNum {
  font-size: 0.24rem;
  color: #333;
}
.head_box > img {
  width: 0.31rem;
  display: inline-block;
  vertical-align: middle;
}
</style>